"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExchangeRates = void 0;
const getExchangeRates = async (supabase) => {
    const { data: exchange_rates, error: exchange_rate_error } = await supabase
        .from("exchange_rates")
        .select("*");
    if (exchange_rate_error) {
        return null;
    }
    return exchange_rates;
};
exports.getExchangeRates = getExchangeRates;
